export type CountryType = 
  "SE" | "FI" | "NO" | "DK" | "ES" |
  "CH" | "DE" | "FR" | "BE" | "NL" |
  "GB" | "US" | "CA" | "IT" | "AT" |
  "PL" | "IE" | "PT" | "GR" | "AU";

export enum unknonwHolidaysCountry{
  Unknown = "Unknown"
}


// WEBPACK FOOTER //
// ./src/components/calendar2/holidays/holidayTypes.ts